import React, { useEffect, useState } from 'react'
import { useAlert } from '../../../contexts/AlertContext'
import CustomAlert from './Alert'
import './GlobalAlert.css'

const AUTO_CLOSE_DELAY = 5000

const TRANSITION_DURATION = 300

const GlobalAlert = () => {
  const { alert, closeAlert } = useAlert()
  const { open, severity, message, validationErrors = [] } = alert
  const isValidation = validationErrors.length > 0

  const [visible, setVisible] = useState(false)
  const [leaving, setLeaving] = useState(false)

  useEffect(() => {
    const timers = []

    if (open || isValidation) {
      setVisible(true)
      setLeaving(false)

      if (!isValidation) {
        const autoTimer = setTimeout(() => {
          setLeaving(true)
          const hideTimer = setTimeout(() => {
            setVisible(false)
            closeAlert()
          }, TRANSITION_DURATION)
          timers.push(hideTimer)
        }, AUTO_CLOSE_DELAY)
        timers.push(autoTimer)
      }
    } else {
      setLeaving(true)
      const hideTimer = setTimeout(() => setVisible(false), TRANSITION_DURATION)
      timers.push(hideTimer)
    }

    return () => timers.forEach(clearTimeout)
  }, [open, isValidation, closeAlert])

  if (!visible) return null

  return (
    <div className={`global-alert-wrapper ${leaving ? 'fade-out' : 'fade-in'}`}>
      <CustomAlert
        severity={severity || 'info'}
        onClose={() => {
          setLeaving(true)
          setTimeout(() => {
            setVisible(false)
            closeAlert()
          }, TRANSITION_DURATION)
        }}
        validationErrors={validationErrors}
        message={message}
      />
    </div>
  )
}

export default GlobalAlert
